import React, { useEffect, useState } from "react";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";
import Loader from "../common/Loader";

const ImagePreview = ({ src, className }) => {
  const [imageSrc, setImageSrc] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let objectUrl = null;

    const processImage = async () => {
      try {
        setLoading(true);

        if (!src) return;

        const response = await fetch(src);
        const blob = await response.blob();

        const extension = src.split(".").pop()?.toLowerCase() || "jpg";

        const file = new File([blob], `image.${extension}`, {
          type: blob.type || `image/${extension}`,
        });

        const isHeic =
          src.toLowerCase().endsWith(".heic") ||
          src.toLowerCase().endsWith(".heif") ||
          file.type?.toLowerCase()?.includes("heic") ||
          file.type?.toLowerCase()?.includes("heif");

        let fileToProcess = file;

        if (isHeic) {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8,
          });

          const jpegBlob = Array.isArray(convertedBlob)
            ? convertedBlob[0]
            : convertedBlob;

          fileToProcess = new File([jpegBlob], "converted.jpg", {
            type: "image/jpeg",
          });
        }

        const compressedFile = await imageCompression(fileToProcess, {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        });

        objectUrl = URL.createObjectURL(compressedFile);

        setImageSrc(objectUrl);
      } catch (error) {
        console.error("Image processing failed:", error);

        setImageSrc(src);
      } finally {
        setLoading(false);
      }
    };

    processImage();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  return (
    <>
      {loading && <Loader />}

      {imageSrc && <img src={imageSrc} alt="" className={className} />}
    </>
  );
};

export default ImagePreview;
